<div class="mrg-left">
  <a href="{{ socialLink.url }}" target="_blank" class="pd-left" *ngFor="let socialLink of socialLinks.tabs">
    <img src="{{ socialLink.title }}" alt="" width="40" />
  </a>
</div>
